<template>
    <div class="row">
        <div class="col-md-3">
            <div class="card custom-card card-body bg-warning tx-white">
                <h6>فیلتر دسته بندی ها</h6>
                <hr class="mb-4 mt-2">
                <label class="ckbox"><input type="checkbox" value="all" id="select-all" checked @change="selectAll"><span>انتخاب همه</span></label>
                <label class="ckbox mt-3" v-for="(category,index) in categories" :key="index"><input type="checkbox" checked @change="changeCategories(category.categoryId)" :value="category.categoryId" :id="'category-' + category.categoryId"><span>{{ category.title }}</span></label>
            </div>
        </div>
        <div class="col-md-9">
            <div class="row" v-if="allCards.length">
                <div class="col-md-4 card-container" v-for="(card,index) in cards" :key="index">
                    <img :src="'https://cardapi.sabinarya.com' + card.address" :alt="card.title">
                    <h5>{{ card.title }}</h5>
                    <div class="row justify-content-center">
                        <div class="col-md-12">
                            <label class="mb-1">موجودی کارت : {{ card.stockCount }}</label>
                            <div class="form-group">
                                <label>انتخاب مبلغ شارژ</label>
                                <select class="form-control mb-3" v-model="card.depositId">
                                    <option value="41">بدون شارژ</option>
                                    <option value="61">مبلغ دلخواه</option>
                                    <option v-for="(deposit,index) in depositsList" :key="index" :value="deposit.depositId">{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(deposit.depositValue) }} ریال</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-12" v-if="card.depositId == 61">
                            <div class="form-group">
                                <label>مبلغ دلخواه (ریال)</label>
                                <input type="tel" class="form-control ltr-input" v-model="card.depositValue" @keyup="e => changeCustomDepositValue(e,index)" @change="e => handleMinAndMax(e,index)">
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-md-12">
                            <div class="form-group">
                                <input type="number" min="0" max="10000" :id="'theme-count-' + index" class="form-control ltr-input" placeholder="تعداد" value="0" v-model="card.orderCount" @keyup="e => cards[index].orderCount = parseInt(cards[index].orderCount)">
                            </div>
                        </div>
                        <div class="col-md-3 pr-0"><button @click="add(card.themeId,card.title,card.price,card.address,index)" :disabled="!card.orderCount || card.orderCount < 1 || card.stockCount < 1 || !card.depositId || (card.depositId == 61 && (!card.depositValue || (card.depositValue && parseInt(card.depositValue.toString().replace(/,/g,'')) < 200000)))" class="btn ripple btn-success btn-icon btn-block"><i class="fe fe-shopping-cart"></i></button></div>
                    </div>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-md-4 card-container" v-for="index in 8" :key="index">
                    <span class="image-placeholder animate"></span>
                    <h5 class="title-placeholder animate"></h5>
                    <div class="row justify-content-center">
                        <div class="col-md-4"><button class="btn ripple btn-placeholder btn-icon animate btn-add-to-card"></button></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FizicalCard',
    props: ['addToCard','depositsList'],
    data(){
        return {
            allCards: [],
            cards: [],
            categories: [],
            selectedCategories: [],
            cartCards: [],
            cardType: 1,
            showLoading: false
        }
    },
    methods: {
        getData(){
            this.$api.get('Cards/AvailableThemes').then(({data}) => {
                setTimeout(() => {
                    this.allCards = data.result;
                    this.cards = data.result;
                },1000);
            });
            this.$api.get('Cards/Categories').then(({data}) => {
                this.categories = data.result;
                this.categories.map(category => {
                    this.selectedCategories.push(category.categoryId);
                });
            });
        },
        add(themeId,title,price,image,index){
            this.addToCard(themeId,title,this.cardType,this.cards[index].orderCount,price,image,this.cards[index].depositId,this.cards[index].depositValue);
            this.cards[index].orderCount = null;
            this.cards[index].depositId = null;
            this.cards[index].depositValue = null;
            this.$forceUpdate();
        },
        handleMinAndMax(e,index){
            let value = this.cards[index].depositValue ? this.cards[index].depositValue.replace(/,/gi,'') : 0;
            if(value < 200000){
                this.$swal({
                    icon: 'error',
                    title: 'خطا',
                    text: 'کمترین مبلغ شارژ 200,000 ریال می باشد'
                });
                this.cards[index].depositValue = '';
            }
        },
        changeCustomDepositValue(e,index){
            let value = this.cards[index].depositValue ? this.cards[index].depositValue.toString().replace(/,/gi,'') : 0;
            let numbers = /^[0-9]*$/;
            if(!numbers.test(e.target.value)){
                e.preventDefault();
            }
            if(value > 20000000)
                value = 20000000;
            value = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(value);
            if(value == 'NaN')
                value = '';
            this.cards[index].depositValue = value;
            this.$forceUpdate();
        },
        setFilterType(element,type){
            let filterTypes = document.getElementsByClassName('filter-item');
            for(let i = 0;i < filterTypes.length;i++){
                if(typeof filterTypes[i] == 'object')
                    filterTypes[i].classList.remove('active');
            }
            element.target.classList.add('active');
        },
        changeCategories(id){
            this.cards = [];
            if(this.selectedCategories.includes(id))
                this.selectedCategories.splice(this.selectedCategories.indexOf(id),1);
            else
                this.selectedCategories.push(id);
            this.selectedCategories.map(categoryId => {
                this.allCards.map(card => {
                    if(card.categories.includes(categoryId))
                        this.cards.push(card);
                });
            });
        },
        selectAll(e){
            this.selectedCategories = [];
            this.cards = [];
            if(e.target.checked)
                this.categories.map(category => {
                    this.selectedCategories.push(category.categoryId);
                    document.getElementById('category-' + category.categoryId).checked = true;
                });
            else
                this.categories.map(category => {
                    document.getElementById('category-' + category.categoryId).checked = false;
                });
            this.selectedCategories.map(categoryId => {
                this.allCards.map(card => {
                    if(card.categories.includes(categoryId))
                        this.cards.push(card);
                });
            });
        }
    },
    created(){
        this.getData();
    }
}
</script>